import { Component, OnInit, Inject } from '@angular/core';
import { FormArray, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Apollo } from 'apollo-angular';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { TIPOS_DE_VIA } from './../../../../constants/constants';
import { OPCIONES_MOTIVO_ALTA } from './../../../../constants/constants';
import { AUTONOMIAS, PROVINCIAS, MUNICIPIOS } from './../../../../constants/constants';

//SERVICIOS
import { ClienteService } from './../../../../services/cliente.service';
import { LoginService } from 'src/app/services/login.service';
import { ValidacionesService } from 'src/app/services/validaciones.service';
//ROUTE

import { UploadDocumentosService } from 'src/app/services/upload-documentos.service';



@Component({
  selector: 'app-perfil-cliente',
  templateUrl: './perfil-cliente.component.html',
  styleUrls: ['./perfil-cliente.component.scss']
})
export class PerfilClienteComponent implements OnInit {

  public userLogged: any

  isLinear = false;
  firstPage: any = {};
  secondPage: any = {};
  tiposVia?: String[];
  motivosAlta?: String[];

  //rutas
  public id?: any;
  public params?: any

  public nombreComercial: any;
  public motivoAlta: any;
  public contactos: any;
  public nombreContacto: any;
  public mailContacto: any

  public addContacts?: boolean;
  public contactsFirstStep?: boolean = true

  public newCliente: any;
  public nCliente: any;
  public oldCliente: any;
  contactosAdicional: any = []
  files:any
  url:any
  date:any
  otherDate:any
  fileName:any
  nameDocumento:any
  autonomias:any
  provincias:any
  municipios:any
  autonomia:any
  provincia:any
  municipio:any

  constructor(private formBuilder: FormBuilder,
    private apollo: Apollo, private loginService: LoginService,
    private clienteService: ClienteService, 
    private uploadService: UploadDocumentosService,
    private validacionService: ValidacionesService) {
    this.userLogged = loginService.getUserData()
    this.tiposVia = TIPOS_DE_VIA
    this.motivosAlta = OPCIONES_MOTIVO_ALTA
    this.autonomias = AUTONOMIAS
  }

  ngOnInit() {
    this.getClienteById()
    this.buildForm()
    this.firstPage.valueChanges.subscribe((val: any) => {
      /* console.log(val) */

    })
   
    

  }

  selectAutonomia(e:any){
    this.provincias = PROVINCIAS
    if (e) {
      this.provincias = this.provincias.filter((provincia:any)=> provincia.COMUNIDAD_AUTONOMA == e.value )
      this.autonomia = e.value
    }
  }

  selectProvincia(e:any){
    this.municipios = MUNICIPIOS
    if (e) {
      this.municipios = this.municipios.filter((municipio:any)=> municipio.PROVINCIA_ID== e.value.ID )
      this.provincia = e.value.NOMBRE
    }
  }

  selectMunicipio(e:any){
    this.municipio = e.value.NOMBRE
    /* console.log(this.municipio); */
    
  }


  private buildForm() {
    this.firstPage = this.formBuilder.group({
      razonSocial: ['', [Validators.required]],
      nombreComercial: ['', [Validators.required]],
      cif: ['', [Validators.required, this.validCif()]],
      via: ['', [Validators.required]],
      nombreVia: ['', [Validators.required]],
      numeroVia: ['', [Validators.required]],
      pta: [''],
      letra: [''],
      localidad: ['', [Validators.required]],
      provincia: ['', [Validators.required]],
      ccaa: ['', [Validators.required]],
      codigoPostal: ['', [Validators.required]],
      actividadEmpresa: ['', [Validators.required]],
      motivoAlta: ['', [Validators.required]],
      datosContacto: ['', [Validators.required]]
    });

    this.secondPage = this.formBuilder.group({
      nombreContacto: ['', [Validators.required]],
      mailContacto: ['', [Validators.required]],
      cargoContacto: ['', [Validators.required]],
      nombreAdicional_0: [''],
      mailAdicional_0: [''],
      cargoAdicional_0: [''],
      nombreAdicional_1: [''],
      mailAdicional_1: [''],
      cargoAdicional_1: [''],
      nombreAdicional_2: [''],
      mailAdicional_2: [''],
      cargoAdicional_2: [''],
      nombreAdicional_3: [''],
      mailAdicional_3: [''],
      cargoAdicional_3: [''],
      policy: ['', [Validators.required]],
    })
  }

  validCif(){
    return (control: AbstractControl):{[key: string]: boolean} | null=>{
    
    
   let cif:any = control.value
  
      if(this.validacionService.checkCif(cif) == false){
      
        return {'validCif':true}
      }
    return null;
    }
  }


  getClienteById() {
    this.apollo.watchQuery<any>({
      query: this.clienteService.getClienteById(),
 
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.oldCliente = data.cliente
        this.contactosAdicional = data.cliente.contacto
        /* console.log(this.oldCliente) */
        this.displayOldCliente()
      })
  }

  displayOldCliente() {
   /*  console.log(this.firstPage); */
    
    if (this.firstPage) {
      this.firstPage.reset()
    }

    this.firstPage.patchValue({
      nombreComercial: this.oldCliente?.nombreComercial,
      motivoAlta: this.oldCliente?.motivoAlta,
      razonSocial: this.oldCliente?.razonSocial,
      cif: this.oldCliente?.cif,
      via: this.oldCliente.domicilio?.tipoVia,
      nombreVia: this.oldCliente.domicilio?.nombre,
      actividadEmpresa: this.oldCliente.actividad,
      numeroVia: this.oldCliente.domicilio?.numero,
      pta: this.oldCliente.domicilio?.pta,
      letra: this.oldCliente.domicilio?.letra,
      localidad: this.oldCliente.domicilio?.localidad,
      provincia: this.oldCliente.domicilio?.provincia,
      codigoPostal: this.oldCliente.domicilio?.codigoPostal,
      ccaa: this.oldCliente.domicilio?.ccaa,
      datosContacto: this.oldCliente?.infoContactoProveedores,
    })

    this.secondPage.patchValue({
      nombreContacto: this.oldCliente?.contactoResponsable?.nombre,
      mailContacto: this.oldCliente?.contactoResponsable?.mail,
      cargoContacto: this.oldCliente?.contactoResponsable?.cargo,
      nombreAdicional_0: this.oldCliente?.contacto[0]?.nombre,
      nombreAdicional_1: this.oldCliente?.contacto[1]?.nombre,
      nombreAdicional_2: this.oldCliente?.contacto[2]?.nombre,
      nombreAdicional_3: this.oldCliente?.contacto[3]?.nombre,
      mailAdicional_0: this.oldCliente?.contacto[0]?.mail,
      mailAdicional_1: this.oldCliente?.contacto[1]?.mail,
      mailAdicional_2: this.oldCliente?.contacto[2]?.mail,
      mailAdicional_3: this.oldCliente?.contacto[3]?.mail,
      cargoAdicional_0: this.oldCliente?.contacto[0]?.cargo,
      cargoAdicional_1: this.oldCliente?.contacto[1]?.cargo,
      cargoAdicional_2: this.oldCliente?.contacto[2]?.cargo,
      cargoAdicional_3: this.oldCliente?.contacto[3]?.cargo,
      /*  nombreAdicional: this.oldCliente.contacto?.nombre,
       mailAdicional: this.oldCliente.contacto?.mail, */
    })
  }

  dropped(files: any){
    this.uploadService.dropped(files).subscribe((res:any)=>{
      this.nameDocumento = res[0].name;
      this.url = res[0].url
    })
    
   }

  public fileOver(){
    /* console.log(event); */
  }

  public fileLeave(){
    /* console.log(event); */
  }

  

  setCliente() {
    const adicional = []
    adicional.push(
      {
        nombre: this.secondPage.value.nombreAdicional_0,
        mail: this.secondPage.value.mailAdicional_0,
        cargo: this.secondPage.value.cargoAdicional_0,
      },
      {
        nombre: this.secondPage.value.nombreAdicional_1,
        mail: this.secondPage.value.mailAdicional_1,
        cargo: this.secondPage.value.cargoAdicional_1,
      },
      {
        nombre: this.secondPage.value.nombreAdicional_2,
        mail: this.secondPage.value.mailAdicional_2,
        cargo: this.secondPage.value.cargoAdicional_2,
      },
      {
        nombre: this.secondPage.value.nombreAdicional_3,
        mail: this.secondPage.value.mailAdicional_3,
        cargo: this.secondPage.value.cargoAdicional_3,
      },
    )
    this.contactosAdicional = adicional
    this.nCliente = { ...this.oldCliente, ...this.firstPage.value }
    this.newCliente = { ...this.nCliente, ...this.secondPage.value }
  }

  updateClienteById() {
    
    this.setCliente()

    if (this.autonomia === undefined) {
      this.autonomia = this.newCliente.domicilio?.ccaa 
    }
    if (this.provincia === undefined) {
      this.provincia = this.newCliente.domicilio?.provincia 
    }
    if (this.municipio === undefined) {
      this.municipio = this.newCliente.domicilio?.localidad 
    }

    this.apollo.mutate({
      mutation: this.clienteService.updateCliente(),
      variables: {
        "input": {
          "where": {
            "id": this.userLogged.cliente.id
          },
          "data": {
            "razonSocial": this.newCliente.razonSocial,
            "nombreComercial": this.newCliente.nombreComercial,
            "cif": this.newCliente.cif,
            "logo": this.url,
            "domicilio": {
              "tipoVia": this.newCliente.via,
              "nombre": this.newCliente.nombreVia,
              "numero": this.newCliente.numeroVia,
              "pta": this.newCliente.pta,
              "localidad": this.municipio,
              "provincia": this.provincia,
              "codigoPostal": this.newCliente.codigoPostal,
              "ccaa": this.autonomia
            },
            "actividad": this.newCliente.actividadEmpresa,
            "motivoAlta": this.newCliente.motivoAlta,
            "infoContactoProveedores": this.newCliente.datosContacto,
            "contactoResponsable": {
              "mail": this.newCliente.mailContacto,
              "nombre": this.newCliente.nombreContacto,
              "cargo": this.newCliente.cargoContacto,
            },
            "contacto": this.contactosAdicional,
            

          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data, errors)
        location.reload()
      }, (error) => {
        console.log('aaaaa', error)
      })
  }

  handleAddContactos(e: Event) {
    this.contactsFirstStep = false;
    this.addContacts = true;
  /*   console.log(this.contactsFirstStep) */
  }

  setAddContactsFalse() {
    this.addContacts = false
    this.contactsFirstStep = true;
  }

  /*   emptyFields(){
      console.log(this.firstPage.get('razonSocial'))
     if(this.firstPage.status === 'INVALID'){
        console.log('campos sin rellenar')
      } 
    }  */

}
